<template>
  <div class="panel_not_data">
    <dl class="image_text">
      <dt>
        <img :src="require(`../../assets/img/not-data/${imgName}.png`)" />
      </dt>
      <dd>{{ message }}</dd>
    </dl>
  </div>
</template>

<script>
export default {
  name: "PanelNotData",
  data() {
    return {};
  },
  props: {
    imgName: {
      type: String,
      default: "score",
      validator: function (value) {
        // 图片的名称，必须匹配下面这些值其中的一个
        return ["queue", "vs", "empty", "search", "score", "business", "box", "live"].includes(value);
      },
    },
    message: {
      type: String,
      default: "暂无相关数据信息~",
    },
  },
};
</script>

<style lang="scss" scoped>
.panel_not_data {
  clear: both;
  width: 100%;
  height: auto;
  overflow: hidden;
  box-sizing: border-box;
  padding: 50px 0px;

  .image_text {
    clear: both;
    width: 100%;
    height: auto;
    overflow: hidden;
    margin: 20px auto;

    dt {
      clear: both;
      width: 1.5rem;
      height: auto;
      overflow: hidden;
      margin: 20px auto;

      img {
        display: block;
        width: 100%;
      }
    }
    dd {
      clear: both;
      width: 100%;
      height: 0.4rem;
      line-height: 0.4rem;
      overflow: hidden;
      text-align: center;
      font-size: 0.14rem;
      color: #999;
    }
  }
}
</style>
